const FEATURES = [
  {
    title: "252 Uniquely Illustrated Questions",
    desc: "Every single question in the assessment has its own colorful, custom illustration — making a deep psychometric assessment feel lively, not like a dry form.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/d90f152f80e411f83bbc12c42c92432d14e0f3caa306b30171c924c54130d867.jpeg",
  },
  {
    title: "Built-In Honesty & Integrity Checks",
    desc: "We quietly track response pacing and auto-restart if you go idle for 15+ minutes, so every report comes with an honest Assessment Confidence rating.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/696ce24bf678e625f548c48d1cdebd0585e4e5ebd0a93ce5fddfeac9b266e234.jpeg",
  },
  {
    title: "Magazine-Style Visual Report",
    desc: "Archetype cards, donut charts and radar graphs replace dense tables — your results read like a personalised feature story, not a spreadsheet.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/b760e697460b020c53ee592c1a327e783a7e0a6a53fb2829150209642b1cf683.jpeg",
  },
  {
    title: "AI-Interpreted Situational Judgment Annex",
    desc: "Real workplace scenarios, your actual choices, and a plain-language AI interpretation of your judgment style — included as a dedicated annex in every report.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/d9a01622fa46cee4d288c4955fc9621a5066053b284fa4383109b9cee577bf22.jpeg",
  },
  {
    title: "Fit Across Engineering, Medicine, Finance & the Arts",
    desc: "A quick directional snapshot of how your profile aligns with widely-considered tracks like Engineering, Medicine, Chartered Accountancy and Creative Arts.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/0387649afe955e9a0863cb4e641c2a9c876097c68991a113da91825caa0be84b.jpeg",
  },
  {
    title: "800+ Careers via the O*NET Taxonomy",
    desc: "Your results are ranked against a vast, continually-expanded universe of real-world occupations — not a shortlist of a dozen generic job titles.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/46013a1e6a67a38543e411e44dfe46f8e4de7ea7ea1d38f22b4e432c64d3b662.jpeg",
  },
  {
    title: "Your Report, In English or Hindi",
    desc: "Switch your entire personalised report between English and Hindi with a single tap — every archetype, insight and career match, freshly translated for you.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/90fcc9eef2ecde0f1b6cc53a8210676bde6182abed0b0a4c74886b3670eb46c4.jpeg",
  },
  {
    title: "Your Hobbies Count Too",
    desc: "Tell us what you love doing outside class — music, sport, coding, art — and we blend those interests directly into your scoring for a more complete, personal picture.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/758e294de5ca56f1da902d1c496d42c52c4b5cf184d036a281a26664897006aa.jpeg",
  },
];

export default function FeatureHighlights() {
  return (
    <section className="bg-white py-24 px-6" data-testid="feature-highlights-section">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-indigo-600 mb-3 text-center">Inside CareerStudy360</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center max-w-3xl mx-auto mb-16">
          Everything That Makes This More Than a Quiz
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              data-testid={`feature-highlight-card-${f.title.slice(0, 10)}`}
              className="rounded-2xl border border-slate-100 overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <img src={f.image} alt={f.title} className="w-full h-40 object-cover" loading="lazy" />
              <div className="p-6">
                <h3 className="font-heading text-base font-semibold text-slate-900 mb-2">{f.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
